import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { currencyFormatting, rateFormatting } from '../../../../common/helpers';
import { Box } from '@mui/system';

export interface LiquidityBreakdownRowData {
  type: string;
  accounts: number;
  interest: number;
  yield: number;
  balances: number;
  funds: number;
}

interface LiquidityBreakdownTableProps {
  rows: LiquidityBreakdownRowData[];
}

const LiquidityBreakdownTable = ({ rows }: LiquidityBreakdownTableProps) => {
  return (
    <Box display="flex" flexDirection="column">
      <Box sx={{ flexGrow: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: '20px',
                  color: 'text.primary',
                  fontWeight: 500,
                  paddingBottom: 0
                }}
              />
              <TableCell
                sx={{
                  fontSize: '18px',
                  color: 'text.primary',
                  paddingBottom: 0
                }}
              >
                Period interest
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '18px',
                  color: 'text.primary',
                  paddingBottom: 0
                }}
              >
                Yield
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '18px',
                  color: 'text.primary',
                  paddingBottom: 0
                }}
              >
                Avg balances
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '18px',
                  color: 'text.primary',
                  paddingBottom: 0
                }}
              >
                % of funds
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.type}
                sx={{
                  '&:last-child td, &:last-child th': {
                    border: 0,
                    paddingTop: '8px'
                  }
                }}
              >
                <TableCell
                  sx={{
                    fontSize: '18px',
                    color: 'text.primary'
                  }}
                >
                  {row.type}
                  <div
                    style={{ color: '#666', fontSize: '16px' }}
                  >{`Accounts: ${row.accounts}`}</div>
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '18px',
                    color: 'text.primary'
                  }}
                >
                  {currencyFormatting(row.interest)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '18px',
                    color: 'text.primary'
                  }}
                >
                  {rateFormatting(row.yield * 100, 2)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '18px',
                    color: 'text.primary',
                    textAlign: 'right'
                  }}
                >
                  {currencyFormatting(row.balances)}
                </TableCell>
                <TableCell
                  sx={{
                    paddingTop: 'none',
                    fontSize: '18px',
                    color: 'text.primary',
                    textAlign: 'right'
                  }}
                >
                  {rateFormatting(row.funds * 100, 0, 1)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box display="flex" flexDirection="column" sx={{ mt: 3 }}>
        <Typography variant="body2" color="textPrimary">
          Accounts that hold both liquid and fixed-term assets are counted in each applicable category.  As such, the sum across categories may exceed the number of accounts shown under “All Accounts.”
        </Typography>
      </Box>
    </Box>
  );
};

export default LiquidityBreakdownTable;
